export default __webpack_public_path__ + "static/media/carousel1.99accd43.png";